const fmt = value => (value == null ? "—" : String(value));

const StatsStrip = ({
  imported,
  updated,
  idNotFound,
  skipped,
  errored,
  isUpsert = false,
}) => {
  // Upsert-aware imports surface Updated + ID not found unconditionally
  // so the operator gets a stable read of "what did upsert do?" even
  // when the matched/missed buckets happen to be empty.
  const showUpdated = isUpsert || (updated != null && updated > 0);
  const showIdNotFound = isUpsert || (idNotFound != null && idNotFound > 0);
  return (
    <div className="tw:flex tw:gap-6 tw:px-5 tw:py-4 tw:bg-card tw:border tw:border-border tw:rounded-lg">
      <div className="tw:flex tw:flex-col tw:gap-1">
        <span className="tw:text-xs tw:text-muted-foreground tw:uppercase tw:tracking-wider">
          Imported
        </span>
        <span className="tw:text-2xl tw:font-semibold tw:text-foreground tw:font-heading">
          {fmt(imported)}
        </span>
      </div>
      {showUpdated && (
        <div className="tw:flex tw:flex-col tw:gap-1">
          <span className="tw:text-xs tw:text-muted-foreground tw:uppercase tw:tracking-wider">
            Updated
          </span>
          <span className="tw:text-2xl tw:font-semibold tw:text-foreground tw:font-heading">
            {fmt(updated)}
          </span>
        </div>
      )}
      {showIdNotFound && (
        <div className="tw:flex tw:flex-col tw:gap-1">
          <span className="tw:text-xs tw:text-muted-foreground tw:uppercase tw:tracking-wider">
            ID not found
          </span>
          <span className="tw:text-2xl tw:font-semibold tw:text-foreground tw:font-heading">
            {fmt(idNotFound)}
          </span>
        </div>
      )}
      <div className="tw:flex tw:flex-col tw:gap-1">
        <span className="tw:text-xs tw:text-muted-foreground tw:uppercase tw:tracking-wider">
          Skipped
        </span>
        <span className="tw:text-2xl tw:font-semibold tw:text-foreground tw:font-heading">
          {fmt(skipped)}
        </span>
      </div>
      <div className="tw:flex tw:flex-col tw:gap-1">
        <span className="tw:text-xs tw:text-muted-foreground tw:uppercase tw:tracking-wider">
          Errored
        </span>
        <span className="tw:text-2xl tw:font-semibold tw:text-foreground tw:font-heading">
          {fmt(errored)}
        </span>
      </div>
    </div>
  );
};

export default StatsStrip;
